// Verbal expressions map
export const expressions = {
    'primary': {
        'title': 'Match Items',
        'expressions': {
            'startOfLine': 'Match the start of a line',
            'find': 'Find by supplied value',
            'anything': 'Match any character any number of times',
            'anythingBut': 'Match anything except supplied characters',
            'anyOf': 'Match any of the supplied characters',
            'maybe': 'Match an optional value',
            'something': 'Match any character at least one time',
            'somethingBut': 'Match any character at least once excluding supplied characters',
            'range': 'Match values within supplied range',
            'word': 'Match any alphanumeric character',
            'digit': 'Match any digit',
            'multiple': 'Match supplied value zero or more times',
            'endOfLine': 'Match the end of a line'
        }
    },
    'modifiers': {
        'title': 'Modifiers',
        'expressions': {
            'or': 'Match an alternative expression',
            'oneOrMore': 'Match the previous expression repeated at least once',
            'repeatPrevious': 'Repeats the previous item'
        }
    },
    'special': {
        'title': 'Special Characters',
        'expressions': {
            'tab': 'Match a tab character',
            'lineBreak': 'Match a line break',
            'whitespace': 'Match a space'
        }
    },
    'capture': {
        'title': 'Capture Groups',
        'expressions': {
            'beginCapture': 'Starts a capturing group',
            'endCapture': 'Ends a capturing group'
        }
    },
    'global': {
        'title': 'Global Modifiers',
        'expressions': {
            'withAnyCase': 'Match the previous expression in any case',
            'stopAtFirst': 'Stop matching once first occurrence is found',
            'searchOneLine': 'Search only the first line of content'
        }
    }
}

// Expressions that take values
export const expressionValues = [
    'find', 'anythingBut', 'maybe', 'somethingBut', 'anyOf', 'range', 'multiple', 'repeatPrevious'
]

// Expression placeholder
export const expressionPlaceholders = {
    'range': 'a-z, 0-9',
    'repeatPrevious': '1, 1-5'
}



// WEBPACK FOOTER //
// ./src/scripts/utilities/expessions.js